// Responsive table for tables created with TablePress plugin

jQuery(document).ready(function() { 
    var titles = [];
    jQuery('table.tablepress thead th').each(function(){
        var title = jQuery(this).text();
        titles.push(title);
    });
    jQuery('table.tablepress tbody tr').each(function(){
        var i = 0;
        jQuery(this).find('td').each(function(){
            var label = titles[i];
            jQuery(this).attr('data-label', label);
            i++;
        });
    });
});